import API from "@/config/api";
import axios from "axios";

export const GET_SUGGESTION_USERS = (params = {}) =>
  axios.get(API.superadmin.suggestions.users, { params });

export const GET_SUGGESTION_MUNICIPALITIES = (params = {}) =>
  axios.get(API.superadmin.suggestions.municipalities, { params });

export const GET_SUGGESTION_SCHOOLS = (params = {}) =>
  axios.get(API.superadmin.suggestions.schools, { params });

export const GET_SUGGESTION_CLASSES = (params = {}) =>
  axios.get(API.superadmin.suggestions.classes, { params });

export const REAUTH_AS_USER = (userId, params = {}) =>
  axios.post(API.superadmin.users.reauth.replace("$user_id", userId), {
    params,
  });

export const GET_PASSAGES = (params = {}) =>
  axios.get(API.superadmin.passages.all, { params });

export const CREATE_PASSAGE_WITHOUT_CARD = (userId, data) =>
  axios.post(API.superadmin.passages.withoutCard.replace("$id", userId), data);

export const GET_OPERATORS = (params = {}) =>
  axios.get(API.superadmin.operators.all, { params });

export const GET_OPERATOR_LOST_CONNECTIONS = (id, params = {}) =>
  axios.get(API.superadmin.operators.disconnects, {
    params: { ...params, operator: id },
  });

export const CREATE_NEW_OPERATOR = (data) =>
  axios.post(API.superadmin.operators.all, data);

export const UPDATE_OPERATOR = (id, data) =>
  axios.patch(API.superadmin.operators.one.replace("$id", id), data);

export const DELETE_OPERATOR = (id) =>
  axios.delete(API.superadmin.operators.one.replace("$id", id));

export const REPLACE_OPERATOR_TOKEN = (id) =>
  axios.put(API.superadmin.operators.token.replace("$id", id));

export const SET_LAST_FULL_UPDATE = (id) =>
  axios.put(API.superadmin.operators.setLastFullUpdate.replace("$id", id));

export const GET_GLOBAL_STATISTICS = (params = {}) =>
  axios.get(API.superadmin.stat.global, { params });

export const GET_MUNICIPALITY_STAT = (params = {}) =>
  axios.get(API.superadmin.stat.municipality, { params });

export const GET_SCHOOLS_STAT = (params = {}) =>
  axios.get(API.superadmin.stat.schools, { params });

export const GET_CARDS = (params = {}) =>
  axios.get(API.superadmin.cards.all, { params });

export const GET_CARDS_DELETED = (params = {}) =>
  axios.get(API.superadmin.cards.deleted, { params });

export const GET_CARDS_BLOCKED = (params = {}) =>
  axios.get(API.superadmin.cards.blocked, { params });

export const BLOCK_CARDS = (payload) =>
  axios.delete(API.superadmin.cards.all, {
    data: { ...payload },
  });

export const BLOCK_CARD = (cardId, data) =>
  axios.delete(API.superadmin.cards.one.replace("$id", cardId), { data });

export const UNLOCK_CARD = (cardId) =>
  axios.delete(API.superadmin.cards.one.replace("$id", cardId), {
    data: { unlock: true },
  });

export const CREATE_CARD = (data) => axios.post(API.superadmin.cards.all, data);

export const EDIT_CARD = (cardId, data) =>
  axios.put(API.superadmin.cards.one.replace("$id", cardId), data);

export const DELETE_CARDS = (payload) =>
  axios.delete(API.superadmin.cards.blocked, {
    data: { ...payload },
  });

export const ACTIVATE_CARDS = (payload) =>
  axios.post(API.superadmin.cards.blocked, {
    ...payload,
  });

export const RESTORE_CARDS = (payload) =>
  axios.post(API.superadmin.cards.deleted, {
    ...payload,
  });

export const GET_CARDS_ACTIONS = (params = {}) =>
  axios.get(API.superadmin.cards.events, { params });

export const GET_NOTIFICATIONS = (params = {}) =>
  axios.get(API.superadmin.notifications.other, { params });

export const GET_SUPPORT_REQUESTS = (params = {}) =>
  axios.get(API.superadmin.supportRequests.all, { params });

export const READ_SUPPORT_REQUEST = (id) =>
  axios.put(API.superadmin.supportRequests.read.replace("$id", id));

export const GET_TEACHERS = (params = {}) =>
  axios.get(API.superadmin.users.teachers, { params });

export const GET_STUDENTS = (params = {}) =>
  axios.get(API.superadmin.users.students, { params });

export const UPDATE_STUDENT_PARENT = (parentId, pupilId, data) =>
  axios.patch(
    API.superadmin.users.parent
      .replace("$id", pupilId)
      .replace("$parent_id", parentId),
    data
  );

export const GET_PAYER = (parentId, pupilId) =>
  axios.get(
    API.superadmin.payer.info
      .replace("$parent_id", parentId)
      .replace("$pupil_id", pupilId)
  );

export const GET_PAYER_TARIFFS = (parentId, pupilId) =>
  axios.get(
    API.superadmin.payer.tariffs
      .replace("$parent_id", parentId)
      .replace("$pupil_id", pupilId)
  );

export const RESUME_PAYER_TARIFF = (parentId, pupilId) =>
  axios.post(
    API.superadmin.payer.resumeCurrent
      .replace("$parent_id", parentId)
      .replace("$pupil_id", pupilId)
  );

export const PAUSE_PAYER_TARIFF = (parentId, pupilId) =>
  axios.post(
    API.superadmin.payer.pauseCurrent
      .replace("$parent_id", parentId)
      .replace("$pupil_id", pupilId)
  );

export const UPDATE_PAYER_TARIFF = (parentId, pupilId, data) =>
  axios.patch(
    API.superadmin.payer.updateCurrent
      .replace("$parent_id", parentId)
      .replace("$pupil_id", pupilId),
    data
  );

export const SET_PAYER_TARIFF = (parentId, pupilId, tariffId) =>
  axios.post(
    API.superadmin.payer.setCurrent
      .replace("$parent_id", parentId)
      .replace("$pupil_id", pupilId)
      .replace("$tariff_id", tariffId)
  );

export const CREATE_MANUAL_PAYMENT = (parentId, pupilId, data) =>
  axios.post(
    API.superadmin.payer.refill
      .replace("$parent_id", parentId)
      .replace("$pupil_id", pupilId),
    data
  );

export const GET_TARIFFS = (params = {}) =>
  axios.get(API.superadmin.tariffs.all, { params });

export const GET_ARCHIVED_TARIFFS = (params = {}) =>
  axios.get(API.superadmin.tariffs.archived, { params });

export const GET_TARIFF_SCHOOLS = (tariffId, params = {}) =>
  axios.get(API.superadmin.units, { params: { ...params, tariff: tariffId } });

export const CREATE_NEW_TARIFF = (data) =>
  axios.post(API.superadmin.tariffs.all, data);

export const UPDATE_TARIFF = (tariffId, data) =>
  axios.patch(API.superadmin.tariffs.one.replace("$id", tariffId), data);

export const PAUSE_TARIFF = (tariffId) =>
  axios.patch(API.superadmin.tariffs.pause.replace("$id", tariffId));

export const RESUME_TARIFF = (tariffId) =>
  axios.patch(API.superadmin.tariffs.resume.replace("$id", tariffId));

export const DELETE_TARIFF = (tariffId) =>
  axios.delete(API.superadmin.tariffs.one.replace("$id", tariffId));

export const DELETE_TARIFF_FROM_SCHOOL = (tariffId, schoolId) =>
  axios.delete(
    API.superadmin.tariffs.school
      .replace("$id", tariffId)
      .replace("$unit_id", schoolId)
  );

export const BIND_TARIFF_TO_ALL_SCHOOLS = (tariffId) =>
  axios.post(API.superadmin.tariffs.massAssign.replace("$id", tariffId));

export const BIND_TARIFF_TO_SCHOOL = (tariffId, schoolId) =>
  axios.post(
    API.superadmin.tariffs.school
      .replace("$id", tariffId)
      .replace("$unit_id", schoolId)
  );

export const GET_TARIFF_REPLACEMENT_TASKS = (params = {}) =>
  axios.get(API.superadmin.tariffs.replace.list, { params });

export const REPLACE_TARIFF = (tariffId, newTariffId) =>
  axios.delete(
    API.superadmin.tariffs.replace.new
      .replace("$id", tariffId)
      .replace("$new_id", newTariffId)
  );

export const GET_TARIFFS_EXTEND_TASKS = (params = {}) =>
  axios.get(API.superadmin.tariffs.massExtend.list, { params });

export const EXTEND_TARIFFS = (data) =>
  axios.post(API.superadmin.tariffs.massExtend.new, data);

export const GET_TARIFFS_PAUSE_TASKS = (params = {}) =>
  axios.get(API.superadmin.tariffs.massPause.list, { params });

export const PAUSE_TARIFFS = (data) =>
  axios.post(API.superadmin.tariffs.massPause.new, data);

export const GET_TARIFFS_RESUME_TASKS = (params = {}) =>
  axios.get(API.superadmin.tariffs.massResume.list, { params });

export const RESUME_TARIFFS = () =>
  axios.post(API.superadmin.tariffs.massResume.new);

export const GET_AGREEMENTS = (params = {}) =>
  axios.get(API.superadmin.agreements.all, { params });

export const GET_CURRENT_AGREEMENT = (params = {}) =>
  axios.get(API.superadmin.agreements.current, { params });

export const CREATE_AGREEMENT = (data) =>
  axios.post(API.superadmin.agreements.all, data);

export const DELETE_AGREEMENT = (id) =>
  axios.delete(API.superadmin.agreements.one.replace("$id", id));

export const UPLOAD_TEACHERS = (payload) =>
  axios.post(API.superadmin.cards.upload.teachers, payload);
export const UPLOAD_PUPILS = (payload) =>
  axios.post(API.superadmin.cards.upload.pupils, payload);

export const GET_SUPPORT_CONTACTS = (payload) =>
  axios.get(API.superadmin.support.contacts.all, payload);

export const CREATE_SUPPORT_CONTACT = (data) =>
  axios.post(API.superadmin.support.contacts.all, data);

export const DELETE_SUPPORT_CONTACT = (id) =>
  axios.delete(API.superadmin.support.contacts.one.replace("$id", id));

export const GET_SUPPORT_CONTACT = (id) =>
  axios.get(API.superadmin.support.contacts.one.replace("$id", id));

export const UPDATE_SUPPORT_CONTACT = (id, data) =>
  axios.patch(API.superadmin.support.contacts.one.replace("$id", id), data);

export const GET_SOFTWARE_VERSION = () =>
  axios.get(API.superadmin.settings.software_version);

export const UPDATE_SOFTWARE_VERSION = (version, file, isRequired) => {
  const formData = new FormData();
  formData.append("version", version);
  formData.append("file", file);
  formData.append("is_required", isRequired);
  return axios.post(API.superadmin.settings.software_version, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const UNDO_UPDATE_SOFTWARE_VERSION = () =>
  axios.delete(API.superadmin.settings.software_version);

export const GET_TARIFF_PAUSE_DAYS = () =>
  axios.get(API.superadmin.settings.tariff_pause_days);

export const UPDATE_TARIFF_PAUSE_DAYS = (payload) =>
  axios.put(API.superadmin.settings.tariff_pause_days, payload);

export const GET_OPERATOR_SETTINGS = () =>
  axios.get(API.superadmin.settings.operator_settings);

export const UPDATE_OPERATOR_SETTINGS = (payload) =>
  axios.put(API.superadmin.settings.operator_settings, payload);

export const GET_NOTIFICATION_MASS_TEMPLATES = (params = {}) =>
  axios.get(API.superadmin.notifications.massTemplates, { params });

export const CREATE_NOTIFICATION_MASS_TEMPLATE = (data) =>
  axios.post(API.superadmin.notifications.massTemplates, data);

export const EDIT_NOTIFICATION_MASS_TEMPLATE = (templateId, data) =>
  axios.patch(
    API.superadmin.notifications.massTemplate.replace("$id", templateId),
    data
  );

export const DELETE_NOTIFICATION_MASS_TEMPLATE = (templateId) =>
  axios.delete(
    API.superadmin.notifications.massTemplate.replace("$id", templateId)
  );

export const SEND_NOTIFICATION_TO_ALL = (data) =>
  axios.post(API.superadmin.notifications.sendToAll, data);

export const SEND_NOTIFICATION_TO_UNIT = (data) =>
  axios.post(API.superadmin.notifications.sendToSchool, data);

export const SEND_NOTIFICATION_TO_PARENT = (data) =>
  axios.post(API.superadmin.notifications.sendToParent, data);
export const GET_TEMPLATES = (params = {}) =>
  axios.get(API.superadmin.templates.all, { params });

export const CREATE_TEMPLATE = (data) =>
  axios.post(API.superadmin.templates.all, data);

export const DELETE_TEMPLATE = (id) =>
  axios.delete(API.superadmin.templates.one.replace("$id", id));

export const UPDATE_TEMPLATE = (templateId, data) =>
  axios.patch(API.superadmin.templates.one.replace("$id", templateId), data);

export const GET_ASSIGNMENTS = (id) =>
  axios.get(API.superadmin.templates.assignments.replace("$id", id));

export const SET_ASSIGNMENT = (id, role, channel) =>
  axios.post(
    API.superadmin.templates.assign
      .replace("$id", id)
      .replace("$role", role)
      .replace("$channel", channel)
  );

export const DELETE_ASSIGNMENT = (id, role, channel) =>
  axios.delete(
    API.superadmin.templates.assign
      .replace("$id", id)
      .replace("$role", role)
      .replace("$channel", channel)
  );

export const GET_API_KEYS = (params = {}) =>
  axios.get(API.superadmin.apiKeys.all, { params });

export const CREATE_NEW_API_KEY = (data) =>
  axios.post(API.superadmin.apiKeys.all, data);

export const UPDATE_API_KEY = (id, data) =>
  axios.patch(API.superadmin.apiKeys.one.replace("$id", id), data);

export const DELETE_API_KEY = (id) =>
  axios.delete(API.superadmin.apiKeys.one.replace("$id", id));

export const REQUEST_REPORT_LOST_CONNECTIONS = (params) =>
  axios.post(API.superadmin.reports.lost_connections, { ...params });

export const REQUEST_REPORT_SENT_SMS = (params) =>
  axios.post(API.superadmin.reports.sent_sms, { ...params });

export const REQUEST_REPORT_ALL_NOTIFICATIONS = (params) =>
  axios.post(API.superadmin.reports.all_notifications, { ...params });

export const REQUEST_REPORT_ISSUED_CARDS = (params) =>
  axios.post(API.superadmin.reports.issued_cards, { ...params });

export const REQUEST_REPORT_BLOCKED_CARDS = (params) =>
  axios.post(API.superadmin.reports.blocked_cards, { ...params });

export const REQUEST_REPORT_PASSAGES = (params) =>
  axios.post(API.superadmin.reports.passages, { ...params });

export const REQUEST_REPORT_STATISTICS = (params) =>
  axios.post(API.superadmin.reports.statistics, { ...params });

export const GET_REPORT_STATUS = (guid) =>
  axios.get(API.superadmin.reports.status.replace("$guid", guid));

export const DOWNLOAD_REPORT = (guid) =>
  axios.get(API.superadmin.reports.download.replace("$guid", guid));

export const GET_OPERATOR_DEVICES = (operatorId) =>
  axios.get(API.superadmin.devices.all, {
    params: { operator: operatorId, page: 1, page_size: 100 },
  });

export const GET_SYNC_TASKS = (params = {}) =>
  axios.get(API.superadmin.syncTasks.all, { params });

export const START_SYNC_TASK = (payload) =>
  axios.post(API.superadmin.syncTasks.all, payload);

export const GET_SYNC_TASKS_UNITS = (params = {}) =>
  axios.get(API.superadmin.syncTasks.units, { params });

export const DELETE_SYNC_TASK = (id) =>
  axios.delete(API.superadmin.syncTasks.one.replace("$id", id));

export const REVOKE_SYNC_TASK = (payload) =>
  axios.post(API.superadmin.syncTasks.revoke, payload);

export const UPDATE_SYNC_TASK_STATUS = (payload) =>
  axios.post(API.superadmin.syncTasks.status, payload);
